const updateTitle = ({ data: { title, titleLocales } }) => {
  return {
    editorChapterTitle: title,
    editorChapterTitleIsEdited: true,
    editorChapterTitleLocales: titleLocales,
    editorHeaderStatus: 'saving'
  };
};

export default updateTitle;
